// i18n.js
// Only English is bundled in the entry chunk. Every other locale lives in
// src/locales/<lng>.js and is fetched as an async webpack chunk the first
// time setAppLanguage() runs for it (webpack creates one chunk per file in
// ./locales). Chunks are content-hashed and immutable-cached, so a repeat
// language switch costs nothing.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en";

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: en,
      },
      // Add more languages here
    },
    lng: "en", // default language
    fallbackLng: "en",
    debug: false,

    interpolation: {
      escapeValue: false, // React already safes from XSS
    },
  });

const loadedLanguages = { en: true };

// Loads the locale chunk for `lng` (once) and registers it with i18next.
// Resolves even on failure so callers never hang; fallbackLng covers gaps.
export const ensureLanguageLoaded = (lng) => {
  if (!lng || loadedLanguages[lng]) return Promise.resolve();
  return import(`./locales/${lng}`)
    .then((mod) => {
      i18n.addResourceBundle(lng, "translation", mod.default, true, true);
      loadedLanguages[lng] = true;
    })
    .catch(() => {});
};

// changeLanguage with the locale chunk guaranteed to be present first, so
// components never suspend or flash untranslated keys.
export const setAppLanguage = (lng) =>
  ensureLanguageLoaded(lng).then(() => {
    if (i18n.language !== lng) i18n.changeLanguage(lng);
  });

export default i18n;
